import Immutable from 'immutable';

export default Immutable.fromJS({
    orderStatus: {
        isValid: false,
        message: 'Please Select Order Status.'
    },
    noAccessReason: {
        isValid: true,
        message: 'Please select a Reason.'
    },
    comment: {
        isValid: false,
        message: 'Comment is Required.'
    },
    closeCodes: {
        isValid: false,
        message: 'Close Codes Required.'
    },
    charges: {
        isValid: true,
        message: null
    },
    dropBury: {
        isValid: false,
        message: null
    },
    insideHomeAccess: {
        isValid: false,
        message: 'Please select Inside Home Access needed status'
    },
    sqc: {
        isValid: false,
        message: null
    },
    justAsk: {
        isValid: true,
        message: null
    },
    pmTicket: {
        isValid: true,
        message: null
    },
    truckRoll: {
        isValid: true,
        message: null
    },
    signalLevels: {
        isValid: false,
        message: "Please enter signal levels"
    },
    deliveryProof: {
        isValid: false,
        message: null
    },
    outletOptimization:
    {
        isValid: false,
        message: null,
    }
});



// WEBPACK FOOTER //
// ./src/reducers/work-order/close-step-validation/initialStepValidation.js